import { Observable } from 'rxjs-compat';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { environment } from "src/environments/environment";


@Injectable({
  providedIn: 'root',
})
export class RestClientService {

  public tenantId: string;
  public url: string = "";

  constructor(public http: HttpClient) {
    // get token data
    this.tenantId = "n47schema1";
    this.url = environment.BACKEND_RACINE_URL ;
  }
  
  getHeadersForHttp() {
    let headers = {
      'Content-Type': 'application/json',
    };
    return headers;
  }

  getHttp(req:any) {
    let customHeaders = this.getHeadersForHttp()
    const httpOptions = {
      headers: new HttpHeaders(customHeaders)
    };

    console.log(this.url+req);
    return new Promise(resolve => {
        this.http.get(this.url+req, httpOptions).subscribe((data: any) => {
          resolve(data);
        }, (err:any) => {
          console.log("Error : " + req);
          console.log(err);
        });
    });
  }

  

  postHttp(req:any, data:any) {
      let customHeaders = this.getHeadersForHttp()
      const httpOptions = {
        headers: new HttpHeaders(customHeaders)
      };

      return new Promise(resolve => {   
          this.http.post(this.url+req, data, httpOptions).subscribe((data: any) => {
            resolve(data);
          }, (err:any) => {
            console.log("Error : " + req);
            console.log(err);
          });
        
      });
  }

   
  put<T>(req: string, data: any): Observable<T> {
    let customHeaders = this.getHeadersForHttp();
    const httpOptions = {
      headers: new HttpHeaders(customHeaders),
    };
    console.log("put", this.url + req, data);
    return this.http.put<T>(this.url + req, data, httpOptions);
  }


  save<T>(req: string, data: any): Observable<T> {
      let customHeaders = this.getHeadersForHttp()
      const httpOptions = {
        headers: new HttpHeaders(customHeaders)
      };
      console.log('post', this.url+req, data);
      return this.http.post<T>(this.url + req, data, httpOptions);
   }
   

   load<T>(req: string): Observable<T> {
    let customHeaders = this.getHeadersForHttp()
    const httpOptions = {
      headers: new HttpHeaders(customHeaders)
    };
    
    console.log('get', this.url+req);
    return this.http.get<T>(this.url+req, httpOptions);
  }


 delete<T>(req: string): Observable<T> {
  let customHeaders = this.getHeadersForHttp();
  const httpOptions = {
    headers: new HttpHeaders(customHeaders),
  };

  console.log("delete", this.url + req);
  return this.http.delete<T>(this.url + req, httpOptions);
}




loadFile<T>(req: string): Observable<T> {
  const httpOptions = {
    responseType: "text" as "json",
  };
  console.log("get", this.url + req);
  return this.http.get<T>(this.url + req, httpOptions);
}

loadFileFile<T>(req: string): Observable<T> {
  const httpOptions = {
    responseType: "arraybuffer" as "json",
  };
  console.log("get", this.url + req);
  return this.http.get<T>(this.url + req, httpOptions);
}

}